export default [
	//单位列表
	{
		path: 'unit',
		name: 'm_unit',
		props: route => route.params,
		component: () => import('@/pages/basic/dic_unit_list')
	},
	//不良品项列表
	{
		path: 'defects',
		name: 'm_defects',
		props: route => route.params,
		component: () => import('@/pages/basic/dic_defects_list')
	},
	//仓库列表
	{
		path: 'warehouse',
		name: 'm_warehouse',
		meta: {
			templateManage: {
				workType: 26,
				print: 'b_warehouse_printtemplate',
			}
		},
		props: route => route.params,
		component: () => import('@/pages/basic/warehouse_list')
	},
	//供应商列表
	{
		path: 'supplier',
		name: 'm_supplier',
		meta: {
			templateManage: {
				workType: 12,
				export: 'b_supplier_exporttemplate'
			}
		},
		props: route => route.params,
		component: () => import('@/pages/basic/supplier_list')
	},
	//客户列表
	{
		path: 'customer',
		name: 'm_customer',
		meta: {
			templateManage: {
				workType: 11,
				export: 'b_customer_exporttemplate'
			}
		},
		props: route => route.params,
		component: () => import('@/pages/basic/customer_list')
	}
];
